export default __webpack_public_path__ + "static/media/b4.a4bcea51.png";